var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-investors-show py-5"},[_c('div',{staticClass:"container"},[(_vm.investor)?_c('AwlCard',[_c('p',{staticClass:"h3"},[_vm._v(_vm._s(_vm.investor.name)+" "+_vm._s(_vm.investor.surname))])]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }